import React, { useState } from "react";
import Button from "../Button";
export default function CloneSample({ sample, store }) {
  const [count, setCount] = useState(0);
  const [position, setPosition] = useState("after");
  const ready = count >= 1;

  if (sample.id) return null;

  return (
    <div className="input-group" style={{ width: 360 }}>
      <span className="input-group-btn">
        <Button
          disabled={!ready}
          onClick={() =>
            count > 0 && store.cloneSample({ sample, count, position }) && setCount(0)
          }
          default
          title="Clone Sample"
          icon="fa-clone"
          className="input-sm"
          tiny
        />
      </span>
      <input
        type="text"
        type="number"
        style={{ padding: 2, textAlign: "center", width: 50 }}
        value={count}
        onChange={(e) => setCount(e.target.value)}
        className="form-control input-sm"
      />
      <select
        className="form-control input-sm"
        value={position}
        style={{ width: 170, borderLeft: 0 }}
        onChange={(e) => setPosition(e.target.value)}
      >
        <option value="after">Insert after this sample</option>
        <option value="end">Insert at the end</option>
      </select>
    </div>
  );
}
